
import { Col, Row, List } from 'antd';
import Text from 'antd/lib/typography/Text';
import ZLSection from '../../containers/zl-section/zl-section';
import React from 'react';
import { IPriceSet } from '../../interfaces/IPriceSet';
import { useSelector } from 'react-redux';
import { languageList } from '../../helpers/lang';
import { IApplicationState } from '../../store';
import useGlobalBookingAlert from '../../hooks/useGlobalBookingAlert';
import RichTextComponent from '../rich-text-component/rich-text-component';


export interface IAlertItemProps {
    venueCode?: string;
    siteAlert?: string;
    priceSet?: IPriceSet;
}

export const BookingAlert: React.FunctionComponent<IAlertItemProps> = (props) => {

    const noVenueCode = "xx-xx"; //param is not optional so need to have a default that wont match anything to pass if  we don't have venue context yet

    const hideVenueAlert = props.siteAlert == null || props.siteAlert.length == 0 || props.priceSet !== undefined;
    const venueAlertBox = (
        <Row align="middle" justify="start" className="alert-info">
            <Col xs={24} sm={24} md={24} lg={24}>
                <Text>
                    <span dangerouslySetInnerHTML={{ __html: props.siteAlert ?? '' }} />
                </Text>
            </Col>
        </Row>
    );


    const currentLocale = useSelector((state: IApplicationState) => state.intl.currentLocale);
    //data loaded from contentful needs to match the locals we have there
    const lang = languageList.find((lng) => lng.code === currentLocale || lng.momentLocale === currentLocale);
    const { loading: gqlLoading, error: gqlError, liveData } = useGlobalBookingAlert(lang?.globalWebsiteLangCode ?? "en", props.venueCode ?? noVenueCode); 

    const globalAlerts = liveData?.bookingAlertCollection?.items ?? [];

    const globalAlertsSection = !gqlLoading && !gqlError
        ? globalAlerts?.map((alert, index) => {
            const hasContent = alert?.alertText?.json;
            if (!hasContent) return null;

            return (
                <ZLSection
                    key={alert.sys?.id ?? index}
                    hidden={!hasContent}
                    active={!!hasContent}
                    alert={true}
                >
                    <Row>
                        <Col>
                            <Text>
                                <RichTextComponent bodyType="body1" jsonData={hasContent} />
                            </Text>
                        </Col>
                    </Row>
                </ZLSection>
            );
        })
        : null;



    return (
        <>
            {globalAlertsSection}

            <ZLSection hidden={hideVenueAlert} active={!hideVenueAlert} alert={true}>
                {venueAlertBox}
            </ZLSection>
        </>
        );
    };